import * as React from "react";

export const CustomerServiceNotice = () => {
    return (
        <p className="text-muted pb-3 pt-2 m-auto">
            Questions about stock, replacement parts, shipping, deliveries or customer service
            issues?<br/>Please <a href="/ContactUs" tabIndex={0} role="link"
                                  aria-label="Go to Contact us details page.">contact customer</a> service directly.
        </p>
    );
};